module.exports = {"dates":{"DateTimeFormat":"dddd Do MMM HH:mm","DateTimeFormatLong":"ddd, D MMM YYYY [at] HH:mm","TimeFormat":"HH:mm","TimeFormatLong":"HH:mm","TimeFormatMeridiem":""}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/locals/en-GB.json
// module id = 937
// module chunks = 2